module.exports = __webpack_public_path__ + "img/our-story.4328ea74.png";